/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseCommandResult } from '../../models/base-command-result';
import { UpdatePlanCommand } from '../../models/update-plan-command';

export interface ApiPlanUpdatePlanPatch$Params {
  
    /**
     * Plan update command
     */
    body?: UpdatePlanCommand
}

export function apiPlanUpdatePlanPatch(http: HttpClient, rootUrl: string, params?: ApiPlanUpdatePlanPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanUpdatePlanPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseCommandResult>;
    })
  );
}

apiPlanUpdatePlanPatch.PATH = '/api/Plan/UpdatePlan';
